import { ThisConnector } from '../../../api/connector'
import { RouteServer } from '../../../graphql/schema/types/route'

export interface RouteServersQueryArgs {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly routeHash: string
}

export interface RouteServersResponse {
  readonly servers: RouteServer[]
}

export function getRouteServers(
  this: ThisConnector,
  { organizationUuid, applicationUuid, routeHash }: RouteServersQueryArgs
) {
  return this.connector.get(
    `/${organizationUuid}/applications/${applicationUuid}/route/${routeHash}/servers`
  )
}
